<template>
    <div class="main-body">
        <div class="header">角色管理</div>
        <div class="out">

            <div class="search2">
              <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="clear: both;"></div>
            </div>


            <el-table class="table" size="mini" :data="tableData" :height="th" v-loading="loading"
                      border :header-cell-style="tabHeader">

                <el-table-column prop="name" label="名称" width="100"></el-table-column>

                <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                <el-table-column prop="listMenu" label="权限">
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.listMenu" v-bind:key="item.menuCode">
                            <span>{{item.name}}</span>,
                        </span>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.name != '超级管理员'" size="medium" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            // 修改table header的背景色
            tabHeader() {
                return 'color:#333;fonts-weight:bold;'
            },


            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },


          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },


            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(isSearch){
              if(isSearch)this.currentPage=1

              this.loading = true;

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"Role/StaffPage",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                      pageIndex:this.currentPage,
                      pageSize:this.pageSize,
                  }
              }).then( (response)=> {
                //console.log(response);
                this.loading = false;
                if(response.data.error == 0){
                    this.tableData = response.data.data.list;
                    this.totalItems = response.data.data.total;
                }

              }).catch(function (error) {
                  console.log(error);
              });

            },


        }
    }

</script>

<style scoped>

</style>
